import React, { useEffect, useState } from "react";
import Header from "../header/header";
import Carousel from "../carousel/carousel";
import "./home.scss";
import FooterComponent from "../footerComponent/footerComponent";
import steps from "../../assets/steps.png";
import video1 from "../../assets/videoContent1.png";
import video2 from "../../assets/videoContent2.png";
import dadaImg from "../../assets/Dada.png";
import events from "../../assets/events.png";
import dummyProfileImg from "../../assets/committeeProfileImg.png";
import axios from "axios";
import { API_URL } from "../../variables";
// import FooterComponent from "../footer/footer";

const Home = () => {
  const [news, setNews] = useState("");
  const [latestProfiles, setLatestProfiles] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getNews();
    getLatestProfiles();
    function handleContextMenu(e) {
      e.preventDefault(); // prevents the default right-click menu from appearing
    }
    // add the event listener to the component's root element
    const rootElement = document.getElementById("home-component");
    rootElement.addEventListener("contextmenu", handleContextMenu);
    // remove the event listener when the component is unmounted
    return () => {
      rootElement.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  const getNews = async () => {
    let res = await axios.get(API_URL + "news");
    if (res?.data?.news_string) setNews(res?.data?.news_string);
  };
  const getLatestProfiles = async () => {
    let res = await axios.get(API_URL + "latest_profiles");
    if (res?.data?.body.length > 0) setLatestProfiles(res?.data?.body);
  };

  return (
    <>
      <Header />
      <Carousel />
      <div className="staticContent">
        <p>{news}</p>
      </div>
      <section className="d-flex align-items-center justify-content-center" id='home-component'>
        <div className="row sectionCenter">
          <div className="col-sm-12 col-md-3 d-flex justify-content-center align-items-center text-white flex-column text-center">
            <img src={dadaImg} alt="" />
            <div className="nameSection text-left">
              <label className="font24px m-0">Mr. Satish Dada Darekar</label>
              <label className="font16px m-0">
                Founder, Pune - Maharashtra
              </label>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 d-flex justify-content-start align-items-left flex-column">
            <h3 className="mb-2 pl-2 pr-2 font22px textDarkRed pt-5 desktopView">
              Our Vision towards digitalization
            </h3>
            <h3 className="mb-2 pl-2 pr-2 font22px textDarkRed phoneView">
              Our Vision towards digitalization
            </h3>
            <p className="mb-4 pl-2 pr-2">
              At Kumbhar Mangalam, our mission is to honor the rich traditions
              of the Kumbhar community while harnessing the power of digital
              innovation.
            </p>
            <p className="mb-4 pl-2 pr-2">
              We aim to create a user-friendly platform that connects grooms,
              brides, and divorced candidates fostering meaningful relationships
              rooted in our cultural values. By promoting digital literacy and
              providing a supportive space for all members.
            </p>
            <p className="mb-2 pl-2 pr-2">
              We strive to strengthen community bonds and empower individuals in
              their search for companionship, ensuring everyone has the
              opportunity for new beginnings.
            </p>
          </div>
          <div className="col-sm-12 col-md-3 d-flex justify-content-center align-items-center">
            <div className="p-2 w-100">
              <iframe
                className="homeVideoFrame"
                width="350"
                height="300"
                src="https://www.youtube.com/embed/wENyrkASKhE" // Replace with your video ID
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <section className="stepsSection p-3 pl-4 pr-4 mt-3 d-flex justify-content-center">
        <img src={steps} alt="" />
      </section>
      <section className="d-flex align-items-center justify-content-center">
        <div className="row sectionCenter mt-4 p-2 d-flex align-items-center">
          <div className="col-sm-12 col-md-6">
            <img alt="" src={events} />
          </div>
          <div className="col-sm-12 col-md-6 ">
            <label className="textDarkRed font22px">Our Services</label>
            <p>
              At Kumbharmangalam®, we specialize in connecting individuals
              within the Kumbhar community, making it easier for you to find
              your ideal match. With countless success stories from couples who
              have found happiness through the Kumbhar Vadhu Var Suchak Mandal,{" "}
            </p>
            <p>
              Our personalized matchmaking services cater to your unique
              preferences, helping you navigate the journey of finding a life
              partner. Join us today and experience a stress-free process
              dedicated to helping you build a happy, meaningful life together
              within the Kumbhar Samaj!
            </p>
          </div>
        </div>
      </section>
      <section className="latestAdded desktopView pb-4">
        <div className="heading p-3">Latest Added</div>
        <div className="p-2 latestAddedWrapper">
          <div className="d-flex justify-content-around">
            {latestProfiles?.map((item, index) => {
              return (
                <div className="rounded bg-white col-md-2 p-0" key={index}>
                  <div className="profileImg position-relative">
                    <img
                      alt=""
                      className="profileImg"
                      src={
                        item.images.length > 0
                          ? `data:image/jpeg;base64,${item.images[0]}`
                          : dummyProfileImg
                      }
                    />
                    <span className="watermarkText">Kumbhar Mangalam</span>
                  </div>
                  <div className="bg-white p-2 latestAddedDetails">
                    <label className="font-bold font14px">
                      {item.member_id} {item.last_name}
                    </label>
                    <label className="font12px">
                      Date of Birth : {item.dob}
                    </label>
                    <label className="font12px">
                      Height : {item.heightFt}'{item.heightInch}"
                    </label>
                    <label className="font12px">
                      Education : {item.education}
                    </label>
                    <label className="font12px">
                      Occupation : {item.occupation}
                    </label>
                    <label className="font12px">
                      Service {item.city}/{item.income_amt} {item.income_type}
                    </label>
                    <label className="font12px">
                      Native Place : {item.native_district}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="p-3 pl-4 pr-4 mt-3 d-flex justify-content-center">
        <img src={video1} alt="" className="videoContentImg" />
        <img src={video2} alt="" className="videoContentImg" />
      </section>
      <FooterComponent />
    </>
  );
};

export default Home;
